import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import "../styles/UsersegmentPie.css";

const COLORS = ["#22c55e", "#f97316"];

const PieChartsZomato = ({selectedRestData ,newUsers = 20, repeatUsers = 120 , p2 = 24, pieTitle}) => {



    //  const newDataValue = selectedRestData[selectedRestData?.length - 2]


    const data = [
      { name: "UM Orders", value: selectedRestData?.p1_orders || 0 },
      { name: "MM Orders", value: selectedRestData?.p2_orders|| 0 },
      {name: "LA Orders", value: selectedRestData?.p3_orders || 0}
    ];

  const total = selectedRestData?.p1_orders + selectedRestData?.p2_orders + selectedRestData?.p3_orders;

  return (
    <div className="analytics-card">

      <h3  className="chart-title" style={{ marginBottom: "10px" }} >{pieTitle}</h3>

      <ResponsiveContainer width="100%" height={310}>
        <PieChart>

          <Pie
            data={data}
            innerRadius={70}
            outerRadius={110}
            paddingAngle={4}
            dataKey="value"
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={COLORS[index]} />
            ))}
          </Pie>

          <Tooltip />
          <Legend wrapperStyle={{ color: "#e2e8f0" }} />

          {/* center value */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            style={{ fontSize: "22px", fontWeight: "600" }}
          >
            {total}
          </text>

        </PieChart>
      </ResponsiveContainer>

    </div>
  );
};

export default PieChartsZomato;